// src/main.jsx

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import { MockAuth0Provider } from './components/auth/MockAuth0Provider.jsx';
import { SKIP_AUTH, AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE } from './lib/config.js';
import { carregarTenant } from './lib/tenant.js';
import { logger } from './lib/logger/index.js';
import { TenantIndisponivelPage } from './pages/TenantIndisponivelPage.jsx';

import App from './App.jsx';
import './index.css';

// ✅ Error handler global para evitar "Cannot convert object to primitive value"
window.addEventListener('error', (event) => {
  logger.error('Erro global capturado', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    error: event.error?.message || event.error?.toString?.() || 'Unknown error'
  });
});

window.addEventListener('unhandledrejection', (event) => {
  logger.error('Promise rejection não tratada', {
    reason: event.reason?.message || event.reason?.toString?.() || event.reason
  });
});

// Utiliza as variáveis carregadas pelo config
const auth0Domain = AUTH0_DOMAIN;
const auth0ClientId = AUTH0_CLIENT_ID;

const AppWithProvider = () => {
  if (SKIP_AUTH) {
    // 3. Se SKIP_AUTH for true, use o provedor mock
    console.warn("!!! A AUTENTICAÇÃO ESTÁ DESABILITADA (VITE_SKIP_AUTH=true) !!!");
    return (
      <MockAuth0Provider>
        <App />
      </MockAuth0Provider>
    );
  }

  // Validação para o provedor real
  if (!auth0Domain || !auth0ClientId || !AUTH0_AUDIENCE) {
    throw new Error("As variáveis de ambiente VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID e VITE_AUTH0_AUDIENCE são obrigatórias quando VITE_SKIP_AUTH é false.");
  }

  // 4. Caso contrário, use o provedor real do Auth0
  // O 'audience' é obrigatório: sem ele, o Auth0 emite um access_token opaco
  // (só válido para /userinfo), não um JWT que a nossa API consegue validar.
  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: AUTH0_AUDIENCE
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <App />
    </Auth0Provider>
  );
};

document.documentElement.lang = 'pt-BR'

// Flags e status do condomínio chegam antes da primeira renderização (spec onboarding-tenant, RF-07).
async function iniciar() {
  const tenant = await carregarTenant();
  const indisponivel = tenant.status === 'NaoEncontrado' || tenant.status === 'Suspenso';

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      {indisponivel ? <TenantIndisponivelPage {...tenant} /> : <AppWithProvider />}
    </React.StrictMode>,
  );
}

iniciar();